/* export const inputStyle =  {

  
    '&multiLine': {
        control: {
            fontFamily: 'Roboto',
           
            borderRadius:"4px",
            width:"480px" ,
             height:"242px",
             fontSize:"14px",
         
          },
          highlighter: {
            padding: 9,
            border: '1px solid transparent',
            lineHeight:2
          },
          input: {
            padding: 9,
            border: '1px solid #DBDEE6',
            lineHeight:2
          },
    },
  

  }
  
  export const inputStyless = {
    control: {
      backgroundColor: '#fff',
      fontSize: 14,
       border:"1px solid #DBDEE6", 
       borderRadius: "4px" ,
        resize:"none",
      fontWeight: 'normal',
      marginBottom:20,
    },
  
    '&multiLine': {
      control: {
        minHeight: 63,
        fontFamily: 'Roboto',
        borderRadius:"4px",
      },
      highlighter: {
        padding: 9,
        border: '1px solid transparent',
        
      },
      input: {
        padding: 9,
        border: '1px solid silver',
       
      },
    },
  
    '&singleLine': {
      display: 'inline-block',
      width: 180,
  
      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },
      input: {
        padding: 1,
        border: '2px inset',
      },
    },
  
    suggestions: {
      list: {
        backgroundColor: 'white',
        border:"1px solid #DBDEE6",
        fontSize: 14,
      },
      item: {
        padding: '5px 15px',
        border:"1px solid #DBDEE6",
        '&focused': {
          backgroundColor: '#cee4e5',
        },
      },
    },
  } */
  
  
  export const inputStyles = {
    control: {
      backgroundColor: '#fff',
      fontSize: 14,
      fontWeight: 'normal',
     
    },
  
    '&multiLine': {
      control: {
        minHeight:242,
        minWidth:"600px" ,
        maxWidth:"600px" ,
        marginBottom:20,
        
      },
      highlighter: {
        padding: 9,
        border: '1px solid transparent',
        lineHeight:2
      },
      input: {
        padding: 9,
        border: '1px solid #DBDEE6',
        borderRadius:"4px !important",
        lineHeight:2,
        minWidth:"600px" ,
        maxWidth:"600px" ,


      },
    },
  
    '&singleLine': {
      display: 'inline-block',
      width: 180,
  
      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },
      input: {
        padding: 1,
        border: '2px inset',
      },
    },
  
    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid #DBDEE6',
        fontSize: 14,
      },
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid #DBDEE6',
        '&focused': {
          backgroundColor: '#cee4e5',
        },
      },
    },
  }
  
  
export const mentionStyles = {
backgroundColor: '#cee4e5',
}   